import { Vector3D } from "@awayjs/core";
import { TouchPoint, MouseEvent, FrameScriptManager } from "@awayjs/scene";
/**
 * MouseManager enforces a singleton pattern and is not intended to be instanced.
 * it provides a manager class for detecting mouse hits on scene objects and sending out mouse events.
 */
var MouseManager = (function () {
    /**
     * Creates a new <code>MouseManager</code> object.
     */
    function MouseManager() {
        var _this = this;
        this._viewLookup = new Array();
        this._containerLookup = new Array();
        this._nullVector = new Vector3D();
        this._queuedEvents = new Array();
        this._mouseUp = new MouseEvent(MouseEvent.MOUSE_UP);
        this._mouseClick = new MouseEvent(MouseEvent.CLICK);
        this._mouseOut = new MouseEvent(MouseEvent.MOUSE_OUT);
        this._mouseDown = new MouseEvent(MouseEvent.MOUSE_DOWN);
        this._mouseMove = new MouseEvent(MouseEvent.MOUSE_MOVE);
        this._mouseOver = new MouseEvent(MouseEvent.MOUSE_OVER);
        this._mouseWheel = new MouseEvent(MouseEvent.MOUSE_WHEEL);
        this._mouseDoubleClick = new MouseEvent(MouseEvent.DOUBLE_CLICK);
        this.onClickDelegate = function (event) { return _this.onClick(event); };
        this.onDoubleClickDelegate = function (event) { return _this.onDoubleClick(event); };
        this.onMouseDownDelegate = function (event) { return _this.onMouseDown(event); };
        this.onMouseMoveDelegate = function (event) { return _this.onMouseMove(event); };
        this.onMouseUpDelegate = function (event) { return _this.onMouseUp(event); };
        this.onMouseWheelDelegate = function (event) { return _this.onMouseWheel(event); };
        this.onMouseOverDelegate = function (event) { return _this.onMouseOver(event); };
        this.onMouseOutDelegate = function (event) { return _this.onMouseOut(event); };
    }
    MouseManager.prototype.registerContainer = function (container) {
        if (container && this._containerLookup.indexOf(container) == -1) {
            container.addEventListener("click", this.onClickDelegate);
            container.addEventListener("dblclick", this.onDoubleClickDelegate);
            container.addEventListener("touchstart", this.onMouseDownDelegate);
            container.addEventListener("mousedown", this.onMouseDownDelegate);
            container.addEventListener("touchmove", this.onMouseMoveDelegate);
            container.addEventListener("mousemove", this.onMouseMoveDelegate);
            container.addEventListener("mouseup", this.onMouseUpDelegate);
            container.addEventListener("touchend", this.onMouseUpDelegate);
            container.addEventListener("mousewheel", this.onMouseWheelDelegate);
            container.addEventListener("mouseover", this.onMouseOverDelegate);
            container.addEventListener("mouseout", this.onMouseOutDelegate);
            this._containerLookup.push(container);
        }
    };
    MouseManager.prototype.unregisterContainer = function (container) {
        if (container && this._containerLookup.indexOf(container) != -1) {
            container.removeEventListener("click", this.onClickDelegate);
            container.removeEventListener("dblclick", this.onDoubleClickDelegate);
            container.removeEventListener("touchstart", this.onMouseDownDelegate);
            container.removeEventListener("mousedown", this.onMouseDownDelegate);
            container.removeEventListener("touchmove", this.onMouseMoveDelegate);
            container.removeEventListener("mousemove", this.onMouseMoveDelegate);
            container.removeEventListener("touchend", this.onMouseUpDelegate);
            container.removeEventListener("mouseup", this.onMouseUpDelegate);
            container.removeEventListener("mousewheel", this.onMouseWheelDelegate);
            container.removeEventListener("mouseover", this.onMouseOverDelegate);
            container.removeEventListener("mouseout", this.onMouseOutDelegate);
            this._containerLookup.slice(this._containerLookup.indexOf(container), 1);
        }
    };
    MouseManager.getInstance = function () {
        if (this._instance)
            return this._instance;
        return (this._instance = new MouseManager());
    };
    MouseManager.prototype.fireMouseEvents = function (forceMouseMove) {
        // If colliding object has changed, queue over/out events.
        if (this._iCollision != this._previousCollidingObject) {
            if (this._previousCollidingObject)
                this.queueDispatch(this._mouseOut, this._mouseMoveEvent, this._previousCollidingObject);
            if (this._iCollision)
                this.queueDispatch(this._mouseOver, this._mouseMoveEvent);
        }
        // Fire mouse move events here if forceMouseMove is on.
        if (forceMouseMove && this._iCollision)
            this.queueDispatch(this._mouseMove, this._mouseMoveEvent);
        var event;
        var dispatcher;
        // Dispatch all queued events.
        var len = this._queuedEvents.length;
        for (var i = 0; i < len; ++i) {
            event = this._queuedEvents[i];
            dispatcher = event.entity;
            // bubble event up the heirarchy until the top level parent is reached
            while (dispatcher) {
                //console.log("dispatcher", dispatcher, dispatcher.adapter.constructor.name);
                if (dispatcher._iIsMouseEnabled()) {
                    dispatcher.dispatchEvent(event);
                }
                dispatcher = dispatcher.parent;
            }
            // not totally sure, but i think just calling it is easier and cheaper than any options for that
            // if nothing is queued, the function will return directly anyway
            FrameScriptManager.execute_queue();
        }
        this._queuedEvents.length = 0;
        this._previousCollidingObject = this._iCollision;
        this._iUpdateDirty = false;
    };
    //		public addViewLayer(view:View)
    //		{
    //			var stg:Stage = view.stage;
    //
    //			// Add instance to mouse3dmanager to fire mouse events for multiple views
    //			if (!view.stageGL.mouse3DManager)
    //				view.stageGL.mouse3DManager = this;
    //
    //			if (!hasKey(view))
    //				_view3Ds[view] = 0;
    //
    //			_childDepth = 0;
    //			traverseDisplayObjects(stg);
    //			_viewCount = _childDepth;
    //		}
    MouseManager.prototype.registerView = function (view) {
        if (view)
            this._viewLookup.push(view);
    };
    MouseManager.prototype.unregisterView = function (view) {
        if (view)
            this._viewLookup.slice(this._viewLookup.indexOf(view), 1);
    };
    MouseManager.prototype.addEventsForViewBinary = function (touchMessage, viewIdx) {
        if (viewIdx === void 0) { viewIdx = 0; }
        var newTouchEvent = {};
        newTouchEvent.clientX = null; // we get the x position from the active touch
        newTouchEvent.clientY = null; // we get the y position from the active touch
        newTouchEvent.touches = [];
        newTouchEvent.changedTouches = [];
        newTouchEvent.preventDefault = function () { };
        var messageView = new Float32Array(touchMessage);
        // transfer touches to event
        var i = 0;
        var cnt = 0;
        var touchCnt = 0;
        cnt++; //we temporary added 1 float to transfer fps from java to js. skip this
        var numTouches = messageView[cnt++];
        var touchtype = messageView[cnt++];
        var activeTouchID = messageView[cnt++];
        var x = 0;
        var y = 0;
        if ((touchtype != 1) && (touchtype != 6) && (touchtype != 12) && (touchtype != 262) && (touchtype != 518)) {
            // if this is not a UP command, we add all touches
            for (i = 0; i < numTouches; i++) {
                var newTouch = {};
                newTouch.identifier = messageView[cnt++];
                newTouch.clientX = messageView[cnt++];
                newTouch.clientY = messageView[cnt++];
                newTouchEvent.touches[i] = newTouch;
            }
            newTouchEvent.changedTouches[0] = newTouchEvent.touches[activeTouchID];
            x = newTouchEvent.changedTouches[0].clientX;
            y = newTouchEvent.changedTouches[0].clientY;
        }
        else {
            // if this is a UP command, we add all touches, except the active one
            if (numTouches == 1) {
                var newTouch = {};
                newTouch.identifier = messageView[cnt++];
                newTouch.clientX = messageView[cnt++];
                newTouch.clientY = messageView[cnt++];
                newTouchEvent.clientX = newTouch.clientX;
                newTouchEvent.clientY = newTouch.clientY;
                x = newTouchEvent.clientX;
                y = newTouchEvent.clientY;
            }
            else {
                for (i = 0; i < numTouches; i++) {
                    var newTouch = {};
                    newTouch.identifier = messageView[cnt++];
                    newTouch.clientX = messageView[cnt++];
                    newTouch.clientY = messageView[cnt++];
                    if (i != activeTouchID) {
                        newTouchEvent.touches[touchCnt] = newTouch;
                    }
                    else {
                        newTouchEvent.clientX = newTouch.clientX;
                        newTouchEvent.clientY = newTouch.clientY;
                        x = newTouchEvent.clientX;
                        y = newTouchEvent.clientY;
                    }
                }
            }
        }
        //console.log("Touch ID:"+touchtype+" activeTouchID "+activeTouchID+" numTouches "+numTouches+" x"+x+" y"+y);
        /*
         public static final int ACTION_DOWN = 0;
         public static final int ACTION_POINTER_1_DOWN = 5;
         public static final int ACTION_POINTER_DOWN = 5;
         public static final int ACTION_BUTTON_PRESS = 11;
         public static final int ACTION_POINTER_2_DOWN = 261;
         public static final int ACTION_POINTER_3_DOWN = 517;


         public static final int ACTION_UP = 1;
         public static final int ACTION_POINTER_1_UP = 6;
         public static final int ACTION_POINTER_UP = 6;
         public static final int ACTION_BUTTON_RELEASE = 12;
         public static final int ACTION_POINTER_2_UP = 262;
         public static final int ACTION_POINTER_3_UP = 518;

         public static final int ACTION_MOVE = 2;


         */
        if ((touchtype == 0) || (touchtype == 5) || (touchtype == 11) || (touchtype == 261) || (touchtype == 517)) {
            this.onMouseDown(newTouchEvent);
        }
        else if ((touchtype == 1) || (touchtype == 6) || (touchtype == 12) || (touchtype == 262) || (touchtype == 518)) {
            this.onMouseUp(newTouchEvent);
        }
        else if (touchtype == 2) {
            this.onMouseMove(newTouchEvent);
        }
        else {
            console.log("recieved unknown touch event-type: " + touchtype);
        }
    };
    MouseManager.prototype.fireEventsForViewFromString = function (touchMessage, viewIdx) {
        if (viewIdx === void 0) { viewIdx = 0; }
        var newTouchEvent = {};
        newTouchEvent.clientX = null; // set the x position from the active touch
        newTouchEvent.clientY = null; // set the y position from the active touch
        newTouchEvent.preventDefault = function () { };
        var touchesFromMessage = touchMessage.split(",");
        // transfer touches to event
        var i = 0;
        var cnt = 0;
        var numTouches = parseInt(touchesFromMessage[cnt++]);
        var touchtype = parseInt(touchesFromMessage[cnt++]);
        var activeTouch = parseInt(touchesFromMessage[cnt++]);
        newTouchEvent.touches = [];
        newTouchEvent.changedTouches = [];
        if ((touchtype != 1) && (touchtype != 6)) {
            for (i = 0; i < numTouches; i++) {
                var newTouch = {};
                newTouch.identifier = touchesFromMessage[cnt++];
                newTouch.clientX = touchesFromMessage[cnt++];
                newTouch.clientY = touchesFromMessage[cnt++];
                newTouchEvent.touches[i] = newTouch;
                newTouchEvent.changedTouches[i] = newTouch;
            }
            ;
            newTouchEvent.changedTouches[i] = newTouchEvent.touches[activeTouch];
        }
        else {
            for (i = 0; i < numTouches; i++) {
                if (i != activeTouch) {
                    var newTouch = {};
                    newTouch.identifier = touchesFromMessage[cnt++];
                    newTouch.clientX = touchesFromMessage[cnt++];
                    newTouch.clientY = touchesFromMessage[cnt++];
                    newTouchEvent.touches[i] = newTouch;
                    newTouchEvent.changedTouches[i] = newTouch;
                }
                else {
                    newTouchEvent.clientX = touchesFromMessage[cnt++];
                    newTouchEvent.clientY = touchesFromMessage[cnt++];
                    cnt++;
                }
            }
            ;
        }
        if (touchtype == 0) {
            this.onMouseDown(newTouchEvent);
        }
        else if (touchtype == 1) {
            this.onMouseUp(newTouchEvent);
        }
        else if (touchtype == 2) {
            this.onMouseMove(newTouchEvent);
        }
        else if (touchtype == 261) {
            this.onMouseDown(newTouchEvent);
        }
        else if (touchtype == 6) {
            this.onMouseUp(newTouchEvent);
        }
    };
    // ---------------------------------------------------------------------
    // Private.
    // ---------------------------------------------------------------------
    MouseManager.prototype.queueDispatch = function (event, sourceEvent, collision) {
        if (collision === void 0) { collision = null; }
        // 2D properties.
        if (sourceEvent) {
            event.delta = sourceEvent.wheelDelta;
            event.ctrlKey = sourceEvent.ctrlKey;
            event.altKey = sourceEvent.altKey;
            event.shiftKey = sourceEvent.shiftKey;
            event.screenX = (sourceEvent.clientX != null) ? sourceEvent.clientX : sourceEvent.changedTouches[0].clientX;
            event.screenY = (sourceEvent.clientY != null) ? sourceEvent.clientY : sourceEvent.changedTouches[0].clientY;
        }
        if (collision == null)
            collision = this._iCollision;
        // 3D properties.
        if (collision) {
            // Object.
            event.entity = collision.entity;
            event.renderable = collision.renderable;
            // UV.
            event.uv = collision.uv;
            // Position.
            event.position = collision.position ? collision.position.clone() : null;
            // Normal.
            event.normal = collision.normal ? collision.normal.clone() : null;
            // Face index.
            event.elementIndex = collision.elementIndex;
        }
        else {
            // Set all to null.
            event.uv = null;
            event.entity = null;
            event.position = this._nullVector;
            event.normal = this._nullVector;
            event.elementIndex = 0;
        }
        // Store event to be dispatched later.
        this._queuedEvents.push(event);
    };
    // ---------------------------------------------------------------------
    // Listeners.
    // ---------------------------------------------------------------------
    MouseManager.prototype.onMouseMove = function (event) {
        event.preventDefault();
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseMove, this._mouseMoveEvent = event);
    };
    MouseManager.prototype.onMouseOut = function (event) {
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseOut, event);
    };
    MouseManager.prototype.onMouseOver = function (event) {
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseOver, event);
    };
    MouseManager.prototype.onClick = function (event) {
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseClick, event);
    };
    MouseManager.prototype.onDoubleClick = function (event) {
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseDoubleClick, event);
    };
    MouseManager.prototype.onMouseDown = function (event) {
        event.preventDefault();
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseDown, event);
    };
    MouseManager.prototype.onMouseUp = function (event) {
        event.preventDefault();
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseUp, event);
    };
    MouseManager.prototype.onMouseWheel = function (event) {
        this.updateColliders(event);
        if (this._iCollision)
            this.queueDispatch(this._mouseWheel, event);
    };
    MouseManager.prototype.updateColliders = function (event) {
        var view;
        var mouseX = (event.clientX != null) ? event.clientX : event.changedTouches[0].clientX;
        var mouseY = (event.clientY != null) ? event.clientY : event.changedTouches[0].clientY;
        var len = this._viewLookup.length;
        for (var i = 0; i < len; i++) {
            view = this._viewLookup[i];
            view._pTouchPoints.length = 0;
            if (event.touches) {
                var touch;
                var len = event.touches.length;
                for (var i = 0; i < len; i++) {
                    touch = event.touches[i];
                    view._pTouchPoints.push(new TouchPoint(touch.clientX + view.x, touch.clientY + view.y, touch.identifier));
                }
            }
            if (this._iUpdateDirty)
                continue;
            if (mouseX < view.x || mouseX > view.x + view.width || mouseY < view.y || mouseY > view.y + view.height) {
                view._pMouseX = null;
                view._pMouseY = null;
            }
            else {
                view._pMouseX = mouseX + view.x;
                view._pMouseY = mouseY + view.y;
                view.updateCollider();
                if (view.layeredView && this._iCollision)
                    break;
            }
        }
        this._iUpdateDirty = true;
    };
    return MouseManager;
}());
export { MouseManager };



// WEBPACK FOOTER //
// ../dist/lib/managers/MouseManager.js